import { kRoute } from "./kRoute";
type tRoute = keyof typeof kRoute;

const kPageTitles: Record<tRoute, string> = {
  P00: "NotFound",
  P01_01: "Apply",
  P01_02: "Application sent!",
  P01_03: "Forgot Password",
  P01_04: "Reset Password",
  P01_05: "Create User",
  P01_06: "Revert Email",
  P01: "Login",
  P02: "Dashboard",
  P03_01: "Order Details",
  P03_02: "Created Orders",
  P03_03: "Abandoned Carts",
  P03_04: "Payouts",
  P03: "All Orders",
  P04_01: "Conversation",
  P04: "Messages",
  P05_01: "Add Promotion",
  P05: "Promotions",
  P06_05: "Connections",
  P06_09: "Brand Settings",
  P06_10: "Retailer Settings",
  P06_11: "Rep Settings",
  P06: "Connections",
  P07: "Commission Log",
  P08_01: "Add a Product",
  P08_02: "Shopify Integration",
  P08: "Products",
  P09: "Your Profile",
  P09_01: "Your Profile Preview",
  P99: "All Brands",
  P10: "Retailer",
  P100: "Brand Details", // This should be dynamic
  P101: "Product Details",
  P102: "Checkout",
  P103: "Create Draft",
  P104: "Shopify Authentication",
  P105: "Referral Link",
  P11: "Reports", // Admin Only
  P12: "Sales Reps",
  P13: "Applications",
  P14: "Customers",
  P15: "Saved Brands",
  P16: "Transactions", // Admin Only
  P16_01: "Transaction Details", // Admin Only
  P17: "My Brands",
  P18: "My Retailers",
  P19: "Referrals & Rewards",
  P20: "Sales Rep",
  P21: "My Brands",
} as const;

type tPageTitle = keyof typeof kPageTitles;

export const getPageTitle = (page: tPageTitle): string => {
  return `${kPageTitles[page]} | bright.blue`;
};
